<script setup lang="ts">
    import type { CustomField } from "common";
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const { field } = defineProps<{
        field: CustomField & { type: "integer" };
    }>();

    const fieldModel = computed({
        get() {
            return orderStore.currentOrder.customFields.find(
                (cf) => cf.id === field.id,
            )?.value as number;
        },
        set(value: number) {
            orderStore.helpers.setCustomField(field.id, value);
        },
    });

    const r$ = orderStore.validation.r$;

    const regleField = computed(() =>
        r$.$fields.customFields.$each.find((rf) => rf.$value.id === field.id),
    );
</script>
<template>
    <shared-labeled-field
        v-slot="{ ariaLabelledby }"
        :label="field.label + (field.required ? ' *' : '')"
    >
        <VNumberInput
            v-model="fieldModel"
            :aria-labelledby="ariaLabelledby"
            variant="outlined"
            density="compact"
            :placeholder="field.placeholder"
            :min="field.configuration?.min"
            :max="field.configuration?.max"
            :error-messages="regleField?.$fields.value.$errors"
            @focusout="regleField?.$fields.value.$touch"
        />
    </shared-labeled-field>
</template>
